// Versão: 1.01
// Data..: 2026-09-24
// Badge de status/prioridade com rótulo traduzido (fonte única no shared).

import { StatusLabels, PriorityLabels } from '@makweb/shared';

export function StatusBadge({ status }: { status: string }) {
  return <span className={`badge badge-${status}`}>{StatusLabels[status] ?? status}</span>;
}

export function PriorityBadge({ priority }: { priority: string }) {
  return <span className={`badge badge-${priority}`}>{PriorityLabels[priority] ?? priority}</span>;
}
